import axios from "axios";
import { HANDLE_CARD_PAYMENT, HANDLE_PAYMENT_TRANSFERS } from "../../api/Endpoints";
import { paymentMethods } from "../helperFunctions";

const createStripePayment = async ({
    cartData = {},
    paymentPopupData = {},
    userData = {},
    checkoutPaymentData = {},
    selectedPaymentType = ""
}) => {
    const result = {
        data: null
    };
    try {
        const data = [];
        if (cartData) {
            cartData?.items.map(item => {
                const payload = {
                    storeID: item?.BOTagAlgorithmData?.storeDetail?._id,
                    companyObjID: item?.BOTagAlgorithmData?.storeDetail?.companyObjID,
                    totalPrice: item?.FormattedData?.totalPrice,
                    type: item?.BOTagAlgorithmData?.type,
                    name: item?.BOTagData?.productName,
                    quantity: item?.BOTagData?.selectedQuantity,
                    deliveryCharges: item?.FormattedData?.deliveryCharges || 0
                };
                data?.push(payload);
            });
        }

        const body = {
            data,
            email: paymentPopupData?.email || userData?.email,
            name: paymentPopupData?.firstName || userData?.firstName,
            customerId: checkoutPaymentData?.customerID || undefined,
            paymentType: selectedPaymentType
        };
        const response = await axios.post(`${process.env.REACT_APP_API_URL}${HANDLE_CARD_PAYMENT}`, body);
        result.data = response?.data || null;

        return result;
    } catch (error) {
        return result;
    }
};

const handlePostPayment = async ({
    res = {},
    savedPaymentMethodType = "",
    BOTagAccountID = "",
    data = {},
    cardElement,
    selectedPaymentType
}) => {
    const returnData = {
        isSuccessFull: false,
        createOrderArgs: null,
        cardInfo: null
    };

    try {
        if (data.isSuccessFull) {
            const payload = {
                connectedAccounts: res?.connectedAccounts,
                uuid: res?.uuid,
                paymentIntentId: res.paymentIntent?.id,
                paymentMethod: data?.paymentMethod,
                bothebotAccountId: BOTagAccountID,
                customerId: res?.customerID,
                selectedPaymentType
            };

            const handleTransferResponse = await axios.post(`${process.env.REACT_APP_API_URL}${HANDLE_PAYMENT_TRANSFERS}`, payload);
            if ((savedPaymentMethodType !== paymentMethods?.CARD || cardElement) && selectedPaymentType === paymentMethods?.CARD) {
                const cardInformation = handleTransferResponse?.data?.cardDetail;
                cardInformation.paymentMethodID = data?.paymentMethod;
                cardInformation.customerID = res?.customerID;
                if (localStorage.getItem("pid")) {
                    cardInformation.cardHolder = cardInformation.cardHolderName;
                    cardInformation.cardExpiration = cardInformation.cardExpDate;
                    returnData.cardInfo = cardInformation;
                }
            }
            if (handleTransferResponse?.data) {
                returnData.isSuccessFull = true;
                returnData.createOrderArgs = [
                    handleTransferResponse?.data?.updateResponse,
                    handleTransferResponse?.data?.cardCredentials,
                    handleTransferResponse?.data?.cardDetail
                ];
            }
        }
        return returnData;
    } catch (error) {
        returnData.isSuccessFull = true;
        returnData.createOrderArgs = [error?.response?.data?.updateResponse];
        return returnData;
    }
};

export { createStripePayment, handlePostPayment };
